export default {
  init() {
    /*$('.large-block, .small-block').on('click', function(){
      window.location = $(this).attr('data-link');
    });*/
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
